import React from 'react';
import PropTypes from 'prop-types';

const CallSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 17}`}
      height={`${height || 16}`}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1468 12.22C15.1468 12.46 15.0935 12.7066 14.9802 12.9466C14.8668 13.1866 14.7202 13.4133 14.5268 13.6266C14.2002 13.9866 13.8402 14.2466 13.4335 14.4133C13.0335 14.58 12.6002 14.6666 12.1335 14.6666C11.4535 14.6666 10.7268 14.5066 9.96016 14.18C9.1935 13.8533 8.42683 13.4133 7.66683 12.86C6.90016 12.3 6.1735 11.68 5.48016 10.9933C4.7935 10.3 4.1735 9.57331 3.62016 8.81331C3.0735 8.05331 2.6335 7.29331 2.3135 6.53998C1.9935 5.77998 1.8335 5.05331 1.8335 4.35998C1.8335 3.90665 1.9135 3.47331 2.0735 3.07331C2.2335 2.66665 2.48683 2.29331 2.84016 1.95998C3.26683 1.53998 3.7335 1.33331 4.22683 1.33331C4.4135 1.33331 4.60016 1.37331 4.76683 1.45331C4.94016 1.53331 5.0935 1.65331 5.2135 1.82665L6.76016 4.00665C6.88016 4.17331 6.96683 4.32665 7.02683 4.47331C7.08683 4.61331 7.12016 4.75331 7.12016 4.87998C7.12016 5.03998 7.0735 5.19998 6.98016 5.35331C6.8935 5.50665 6.76683 5.66665 6.60683 5.82665L6.10016 6.35331C6.02683 6.42665 5.9935 6.51331 5.9935 6.61998C5.9935 6.67331 6.00016 6.71998 6.0135 6.77331C6.0335 6.82665 6.0535 6.86665 6.06683 6.90665C6.18683 7.12665 6.3935 7.41331 6.68683 7.75998C6.98683 8.10665 7.30683 8.45998 7.6535 8.81331C8.0135 9.16665 8.36016 9.49331 8.7135 9.79331C9.06016 10.0866 9.34683 10.2866 9.5735 10.4066C9.60683 10.42 9.64683 10.44 9.6935 10.46C9.74683 10.48 9.80016 10.4866 9.86016 10.4866C9.9735 10.4866 10.0602 10.4466 10.1335 10.3733L10.6402 9.87331C10.8068 9.70665 10.9668 9.57998 11.1202 9.49998C11.2735 9.40665 11.4268 9.35998 11.5935 9.35998C11.7202 9.35998 11.8535 9.38665 12.0002 9.44665C12.1468 9.50665 12.3002 9.59331 12.4668 9.70665L14.6735 11.2733C14.8468 11.3933 14.9668 11.5333 15.0402 11.7C15.1068 11.8666 15.1468 12.0333 15.1468 12.22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

CallSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CallSvg;
